module.exports = __webpack_public_path__ + "static/media/balloon_outlet.443f2426.svg";